(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('RequiredDocument', RequiredDocument);

    RequiredDocument.$inject = ['$resource', 'DateUtils'];

    function RequiredDocument ($resource, DateUtils) {
        var resourceUrl =  'api/required-documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.received = DateUtils.convertLocalDateFromServer(data.received);
                        data.approved = DateUtils.convertLocalDateFromServer(data.approved);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.received = DateUtils.convertLocalDateToServer(data.received);
                    data.approved = DateUtils.convertLocalDateToServer(data.approved);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.received = DateUtils.convertLocalDateToServer(data.received);
                    data.approved = DateUtils.convertLocalDateToServer(data.approved);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
